import { push } from 'react-router-redux'

export const changeRoute = (pathName) => {
  return (dispatch) => {
    dispatch(push(pathName))
  }
}



// WEBPACK FOOTER //
// ./src/actions/route.js